import React, { FC, SVGAttributes } from 'react'

const CheckGreenIcon: FC<SVGAttributes<SVGElement>> = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
        <rect width="16" height="16" fill="#05A809" rx="8"></rect>
        <path stroke="#fff" strokeWidth="2" d="M3 8l3.071 3.5 6.429-7"></path>
    </svg>
)

export default CheckGreenIcon
